import React, { useRef, useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import './MehendiPreview.css';

const MEHENDI_DESIGNS = [
    { id: 1, name: 'Traditional Mandala', url: 'https://img.icons8.com/color/512/henna-tattoo.png' },
    { id: 2, name: 'Floral Arabic', url: 'https://img.icons8.com/color/512/lotus.png' },
    { id: 3, name: 'Rajasthani Dulhan', url: 'https://img.icons8.com/color/512/peacock.png' },
    { id: 4, name: 'Modern Minimalist', url: 'https://img.icons8.com/color/512/flower-bouquet.png' },
    { id: 5, name: 'Indo-Western', url: 'https://img.icons8.com/color/512/sun.png' }
];

const MehendiPreview: React.FC = () => {
    const videoRef = useRef<HTMLVideoElement>(null);
    const history = useHistory();
    const [selectedDesign, setSelectedDesign] = useState(MEHENDI_DESIGNS[0]);
    const [hasCamera, setHasCamera] = useState<boolean | null>(null);
    const [isFrontCamera, setIsFrontCamera] = useState(false);

    const startCamera = async () => {
        try {
            const stream = await navigator.mediaDevices.getUserMedia({
                video: { facingMode: isFrontCamera ? 'user' : 'environment' }
            });
            if (videoRef.current) {
                videoRef.current.srcObject = stream;
            }
            setHasCamera(true);
        } catch (err) {
            console.error('Camera access error:', err);
            setHasCamera(false);
        }
    };

    const toggleCamera = () => {
        if (videoRef.current && videoRef.current.srcObject) {
            const stream = videoRef.current.srcObject as MediaStream;
            stream.getTracks().forEach(track => track.stop());
        }
        setIsFrontCamera(!isFrontCamera);
    };

    useEffect(() => {
        startCamera();
        return () => {
            if (videoRef.current && videoRef.current.srcObject) {
                const stream = videoRef.current.srcObject as MediaStream;
                stream.getTracks().forEach(track => track.stop());
            }
        };
    }, [isFrontCamera]);

    return (
        <div className="mehendi-ar-container">
            <header className="ar-header">
                <button className="back-btn-circle" onClick={() => history.goBack()}>←</button>
                <div className="ar-title">
                    <h1>Mehendi Try-On</h1>
                    <span>AR Preview Concept</span>
                </div>
                <button className="flip-btn-circle" onClick={toggleCamera}>🔄</button>
            </header>

            <div className="camera-view">
                {hasCamera === false ? (
                    <div className="camera-error">
                        <span className="error-icon">📸</span>
                        <h3>Camera Access Required</h3>
                        <p>Please enable camera permissions to try on Mehendi designs.</p>
                        <button className="retry-btn" onClick={startCamera}>Grant Access</button>
                    </div>
                ) : (
                    <>
                        <video ref={videoRef} autoPlay playsInline className="ar-video-feed" />
                        <div className="ar-overlay">
                            <img
                                src={selectedDesign.url}
                                alt={selectedDesign.name}
                                className="mehendi-overlay-img"
                            />
                        </div>
                        <div className="ar-instructions">
                            <p>Position your hand in the frame to preview the design ✨</p>
                        </div>
                    </>
                )}
            </div>

            <div className="design-picker-panel">
                <div className="picker-header">
                    <h3>Select a Design</h3>
                    <span className="design-name">{selectedDesign.name}</span>
                </div>
                <div className="design-rail">
                    {MEHENDI_DESIGNS.map((design) => (
                        <div
                            key={design.id}
                            className={`design-thumbnail ${selectedDesign.id === design.id ? 'active' : ''}`}
                            onClick={() => setSelectedDesign(design)}
                        >
                            <img src={design.url} alt={design.name} />
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default MehendiPreview;
